import { connect } from "react-redux";

import { RootState } from "@reducers";

import SubmitExam from "./SubmitExam";

export interface OwnProps {
  isOpen: boolean;
  onSubmit?: () => void;
  onCancel?: () => void;
}

const mapStateToProps = (state: RootState, props: OwnProps) => ({
  ...props,
  exam: state.applicant.exam,
});

const mapDispatchToProps = () => ({});

/**
 * Wrapped component
 */
const wrappedComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SubmitExam);

export default wrappedComponent;
